import {useMutation, useQuery} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {TicketSubCategory} from "../../../Shared/Types/TicketSubCategory";

const apiUrl = "api/ticket-subcategory";
const timeout = 30000;

const handleAccepted = (res: any) => res.data;
const handleRejected = (err: any) => console.error("Error fetching data:", err);

export const CreateTicketSubCategory = () => {
    return useMutation((data: TicketSubCategory) => axios.post(apiUrl, data, {timeout}).then(handleAccepted, handleRejected));
};

export const UpdateTicketSubCategory = () => {
    return useMutation((data: TicketSubCategory) => axios.put(apiUrl, data, {timeout}).then(handleAccepted, handleRejected));
};

export const DeleteTicketSubCategory = () => {
    return useMutation((id: number) => axios.delete(`${apiUrl}/${id}`, {timeout}).then(handleAccepted, handleRejected));
};

export const FindByIdTicketSubCategory = (id: number | null) => {
    return useQuery(
        ['findbyid-ticketsubcategory', id],
        () => axios.get(`${apiUrl}/${id}`, {timeout}).then(handleAccepted, handleRejected),
        {enabled: !!id}
    );
};

export const FindAllTicketSubCategory = () => {
    return useQuery(
        'findall-ticketsubcategory',
        () => axios.get(apiUrl, {timeout}).then(handleAccepted, handleRejected)
    );
};

export const FindByCategoryTicketSubCategory = (id: number | null) => {
    return useQuery(
        ['findbycategory-ticketsubcategory', id],
        () => axios.get(`${apiUrl}?categoryId=${id}`, {timeout}).then(handleAccepted, handleRejected),
        {enabled: !!id}
    );
};

export const SearchTicketSubCategory = (pagedSearchParams: PagedSearchParams) => {
    const params = pagedSearchParams ? pagedSearchParams.toURLSearchParams() : null;

    return useQuery(
        ["search-ticketsubcategory", pagedSearchParams],
        () => axios.get(`${apiUrl}/search`, {params, timeout}).then(handleAccepted, handleRejected)
    );
};
